module.exports = __webpack_public_path__ + "fonts/YekanBakhFaNumLight.75924cf.ttf";